// src/components/HighlightKeyword.jsx

import React, { useEffect } from 'react'; // Ensure useEffect is imported
import { useLocation } from 'react-router-dom';

const HighlightKeyword = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        element.classList.add('highlight');
        setTimeout(() => {
          element.classList.remove('highlight');
        }, 2000);
      }
    }
  }, [location]);

  return null;
};

export default HighlightKeyword;